var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('el-col',[_c('rabbey-table3',{attrs:{"columns":_vm.columns,"data":_vm.Item,"summary-method":_vm.getSummaries,"show-summary":"","default-expand-all":"","stripe":""}})],1),_c('el-button',{attrs:{"type":"primary","icon":"el-icon-download"},on:{"click":_vm.exportReport}},[_vm._v("Exportar")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }